import { render } from "./AddPoke.vue?vue&type=template&id=3e95136c&scoped=true"
import script from "./AddPoke.vue?vue&type=script&lang=js"
export * from "./AddPoke.vue?vue&type=script&lang=js"

import "./AddPoke.vue?vue&type=style&index=0&id=3e95136c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e95136c"

export default script